<template>
  <my-dialog
    @hideMask="$emit('update:deleteDialogFlag', false)"
    :dialogFlag="deleteDialogFlag"
    width="330px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="dialog_container">
      <div class="dialog_container_header">
        <h3 class="header_title">提示</h3>
        <div class="close_btn" @click="$emit('update:deleteDialogFlag', false)">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <div class="dialog_container_body">直播删除后无法恢复，请谨慎操作</div>
      <div class="dialog_container_footer">
        <div class="confirm_btn" @click="handleConfirm">确定删除</div>
        <div class="cancel_btn" @click="$emit('update:deleteDialogFlag', false)">取消删除</div>
      </div>
      <div class="loading_mask" v-if="deleteDialogLoading">
        <a-spin />
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data() {
    return {
      deleteDialogLoading: false
    }
  },
  props: {
    deleteDialogFlag: {
      type: Boolean,
      default: false
    },
    rowDetail: {
      type: Object,
      default: {}
    }
  },
  methods: {
    async handleConfirm() {
      try {
        this.deleteDialogLoading = true
        const result = await this.$http.deletedLive(this.rowDetail.liveId)
        this.deleteDialogLoading = false
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        this.$emit('update:deleteDialogFlag', false)
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
        this.$message.success('删除成功')
        this.$emit('refresh')
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_container {
  position: relative;
  .dialog_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #eaeaea;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .dialog_container_body {
    padding: 15px;
    text-align: center;
  }
  .dialog_container_footer {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border-top: 1px solid #eaeaea;
    display: flex;
    justify-content: center;
    .confirm_btn,
    .cancel_btn {
      width: 74px;
      height: 32px;
      border-radius: 5px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      box-shadow: 0 0 5px #f5f5f5;
      letter-spacing: 1px;
    }
    .confirm_btn {
      border: 1px solid #d9d9d9;
      color: #595959;
      background-color: #fff;
      margin-right: 15px;
      &:hover {
        background-color: #f5f5f5;
      }
      &:active {
        background-color: #fff;
      }
    }
    .cancel_btn {
      background-color: #2090ff;
      color: #fff;
      &:hover {
        background-color: #1974ce;
      }
      &:active {
        background-color: #2090ff;
      }
    }
  }
}
.loading_mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}
</style>
